import Button from '@CS/components/Button';
import { type CSSProperties, useState } from 'react';
import { type PopupProps, Popup, FADE_DURATION } from '@CS/components/Popups';

import {
  ConfirmTitle,
  ConfirmMessage,
  ContentContainer,
  ButtonsContainer
} from './Confirmation.styles';

type ConfirmationProps = PopupProps & {
  translations: Record<string, string>;
  onSubmit: () => void;
  onCancel: () => void;
};

export const Confirmation = ({
  translations,
  onSubmit,
  onCancel,
  onClose,
  ...props
}: ConfirmationProps) => {
  const [visible, setVisible] = useState(true);

  const onClick = (confirm: boolean) => {
    setTimeout(confirm ? onSubmit : onCancel, FADE_DURATION);
    setVisible(false);
  };

  const dialogStyle = {
    flexDirection: 'column',
    alignContent: 'center',
    display: 'flex'
  } as CSSProperties;

  return (
    <Popup
      customStyle={dialogStyle}
      onClose={onClose}
      close={!visible}
      {...props}
    >
      <ContentContainer>
        <ConfirmTitle>{translations.leave_title}</ConfirmTitle>
        <ConfirmMessage>{translations.leave_description}</ConfirmMessage>
      </ContentContainer>

      <ButtonsContainer>
        <Button
          onClick={() => onClick(false)}
          text={translations.leave_cta_stay}
          width="100%"
        />

        <Button
          onClick={() => onClick(true)}
          text={translations.leave_cta_leave}
          variant="secondary"
          width="100%"
        />
      </ButtonsContainer>
    </Popup>
  );
};
